module.exports = __webpack_public_path__ + "img/img-slider.6afeb09c.svg";